export enum LoadingStatus {
  NotSet = 'notSet',
  Loading = 'loading',
  Error = 'error',
  Success = 'success',
}
